import { enrichRosterWithNextMovement } from './nextMovement';

function rosterRowFromEmployee(emp) {
  return {
    employee_id: emp.id,
    name: emp.name,
    position: emp.position,
    department: emp.department,
    team: emp.team,
    cost_code: emp.cost_code,
    point_of_hire: emp.point_of_hire,
    is_on_site: false,
    is_travel_day: false,
    status_code: null,
    status_description: null,
    schedule_row_id: null,
    is_first_on_site: false,
  };
}

/** All active employees, merged with the selected day's schedule when present. */
export function buildFullRoster(activeEmployees, dailyScheduleRows, scheduleRangeRows, viewDate) {
  const scheduleByEmployee = new Map();
  (dailyScheduleRows || []).forEach((row) => {
    if (row.employee_id != null) {
      scheduleByEmployee.set(row.employee_id, row);
    }
  });

  const merged = (activeEmployees || []).map((emp) => {
    const scheduled = scheduleByEmployee.get(emp.id);
    return scheduled ?? rosterRowFromEmployee(emp);
  });

  return enrichRosterWithNextMovement(merged, scheduleRangeRows, viewDate);
}
